import { Flame } from "lucide-react";
import { BUSINESS } from "@/lib/config";

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="bg-slate-950 text-slate-400 border-t border-slate-800"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-14 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <img
              src={BUSINESS.logoUrl}
              alt={BUSINESS.name}
              className="h-12 w-12 object-cover border border-slate-700"
            />
            <div className="leading-tight">
              <div className="font-display font-black text-white text-lg">
                BID DVC
              </div>
              <div className="text-[10px] tracking-[0.25em] uppercase text-slate-500 font-bold">
                Dryer Vent Cleaning
              </div>
            </div>
          </div>
          <p className="text-sm leading-relaxed max-w-sm">
            Preventing dryer fires, lowering energy bills, and extending the
            life of your dryer — one vent at a time.
          </p>
        </div>

        <div>
          <div className="text-xs uppercase tracking-widest font-bold text-white mb-4">
            Contact
          </div>
          <ul className="space-y-2 text-sm">
            <li>
              <a href={`tel:${BUSINESS.phoneRaw}`} className="hover:text-white">
                {BUSINESS.phone}
              </a>
            </li>
            <li>
              <a href={`mailto:${BUSINESS.email}`} className="hover:text-white">
                {BUSINESS.email}
              </a>
            </li>
            <li>{BUSINESS.address}</li>
            <li>{BUSINESS.hours}</li>
          </ul>
        </div>

        <div>
          <div className="text-xs uppercase tracking-widest font-bold text-white mb-4">
            Explore
          </div>
          <ul className="space-y-2 text-sm">
            <li>
              <a href="#services" className="hover:text-white">
                Services
              </a>
            </li>
            <li>
              <a href="#calculator" className="hover:text-white">
                Get a quote
              </a>
            </li>
            <li>
              <a href="#service-area" className="hover:text-white">
                Service area
              </a>
            </li>
            <li>
              <a
                href={BUSINESS.googleMapsUrl}
                target="_blank"
                rel="noreferrer"
                className="hover:text-white"
              >
                Google reviews
              </a>
            </li>
            <li>
              <a href={`tel:${BUSINESS.phoneRaw}`} className="hover:text-white">
                Call to book
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row gap-3 items-center justify-between text-xs uppercase tracking-widest font-bold text-slate-500">
          <span>© {new Date().getFullYear()} {BUSINESS.name}. All rights reserved.</span>
          <span>Licensed · Insured · Certified</span>
        </div>
      </div>
    </footer>
  );
}
